module.exports = __webpack_public_path__ + "img/uninstall-gbwhatsapp-x1.552ba36e.webp";